<div class="shift-lookup-container">

    <div class="report-menu">
      <div class="report-title-with-actions">
        <div class="report-name">
          Shift Lookup
        </div>

        <div class="report-menu__actions">
          @if (selectedCategory === ShiftLookupCategory.VEHICLES && hasVehicleMgmtAccess$ | async) {
            <button mat-icon-button
                    [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_VEHICLES]"
                    [matTooltip]="'Manage Vehicles'"
                    class="report-button"
            >
              <mat-icon>directions_car</mat-icon>
            </button>
          } @else if (selectedCategory === ShiftLookupCategory.DRIVERS && hasUserMgmtAccess$ | async) {
            <button mat-icon-button
                    [routerLink]="['/' + RootRoute.SETTINGS, SettingsRoute.MANAGE_USERS]"
                    [matTooltip]="'Manage Drivers'"
                    class="report-button"
            >
              <mat-icon>person</mat-icon>
            </button>
          }

          <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                             [active]="showingFilterBar"
                             (toggled)="toggleFilter()"
          ></app-filter-button>

          <button
            mat-icon-button
            (click)="closeInsight()"
            [matTooltip]="'Close'"
            class="report-button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div class="report-subtitle">
        Browse vehicles and drivers to review past shifts
      </div>
    </div>

    <app-filter-bar
      class="header-container__filters"
      [origin]="'shiftLookup'"
      [showingFilterBar]="showingFilterBar"
      [useDateFilter]="true"
      (dateFilterChanged)="dateFilterChanged($event)"
      (appliedFiltersChanged)="appliedFiltersCount = $event"
    >
    </app-filter-bar>

    <div class="content">
        <div class="selector-container">
            <div class="selector-container__type">
                <app-vertical-icon-button
                    [input]="vehicleFilterButton"
                ></app-vertical-icon-button>
                <app-vertical-icon-button
                        [input]="driverFilterButton"
                ></app-vertical-icon-button>
            </div>
            <div class="selector-container__list">
                <div class="selector-container__list-inner" tabindex="0">
                  @for (item of items; track $index) {
                    <app-action-menu-item
                      [input]="item">
                    </app-action-menu-item>
                  }
                </div>
            </div>
        </div>
        <div class="selector-cards-divider">
        </div>
        <div class="shift-cards-container" (scroll)="onScroll($event)">
          @if (!!selectedId) {
            <div class="shift-cards-container-inner">
              @if (shiftsLoading) {
                <mat-spinner></mat-spinner>
              } @else {
                @for (shift of shifts; track $index) {
                  <app-shift-detail-card
                    [configuration]="configuration"
                    [shift]="shift"
                    [source]="selectedCategory"
                    (shiftDeleted)="handleShiftDeleted()"
                  ></app-shift-detail-card>
                }
              }
            </div>
          } @else {
            <app-blank-page
              class="centered__page__container"
              headline="No Driver or Vehicle Selected"
              text="Select a Vehicle or Driver from the list on the left to see all associated shifts."
            >
            </app-blank-page>
          }
        </div>
    </div>
</div>
